import { useLocale } from '@/i18n/locale-context';
import { useOnline } from '@/lib/hooks';

/**
 * Phase 7 task list: an offline banner.
 *
 * `role="status"` rather than `alert`: losing connectivity is worth announcing, but not
 * worth interrupting whatever a screen-reader user was reading. The page keeps whatever
 * it already rendered — which is the point of the message.
 */
export function OfflineBanner() {
  const { t } = useLocale();
  const online = useOnline();

  if (online) return null;

  return (
    <div
      role="status"
      className="bg-ink px-gutter py-2 text-center text-sm font-semibold text-white"
    >
      {t('error.offline')}
    </div>
  );
}
